/**
 * Returns a list of the passive verbs from Arabic verbs that have long vowel in their root
 * used for the Arabic passive voice assessment.
 * @returns {Array} The list with passive verbs.
 */
export default function() {
	return [
		"غودرت",
		"غودر",
		"غودرتما",
		"غودرا",
		"غودرتا",
		"غودرنا",
		"غودرتم",
		"غودرتنّ",
		"غودروا",
		"غودرن",
		"مغادر",
		"محثوث",
		"تجرى",
		"يجرى",
		"مجرى",
		"تبقى",
		"يبقى",
		"مبقى",
		"تجوهلت",
		"تجوهل",
		"تجوهلت",
		"تجوهلتما",
		"تجوهلا",
		"تجوهلتا",
		"تجوهلنا",
		"تجوهلتم",
		"تجوهلتنّ",
		"تجوهلوا",
		"تجوهلن",
		"متجاهل",
		"تشوورت",
		"تشوور",
		"تشوورتما",
		"تشوورا",
		"تشوورتا",
		"تشوورنا",
		"تشوورتم",
		"تشوورتنّ",
		"تشووروا",
		"تشوورن",
		"متشاور",
		"نوقشت",
		"نوقش",
		"نوقشتما",
		"نوقشا",
		"نوقشتا",
		"نوقشنا",
		"نوقشتم",
		"نوقشتنّ",
		"نوقشوا",
		"نوقشن",
		"مناقش",
		"معود",
		"ترتدى",
		"يرتدى",
		"نرتدى",
		"مرتدى",
		"تنتهى",
		"ينتهى",
		"ننتهى",
		"تجووزت",
		"تجووز",
		"تجووزتما",
		"تجووزا",
		"تجووزتا",
		"تجووزنا",
		"تجووزتم",
		"تجووزتنّ",
		"تجووزوا",
		"تجووزن",
		"حوولت",
		"حوول",
		"حوولتما",
		"حوولا",
		"حوولتا",
		"حوولنا",
		"حوولتم",
		"حوولتنّ",
		"حوولوا",
		"حوولن",
		"تعولجت",
		"تعولج",
		"تعولجتما",
		"تعولجا",
		"تعولجتا",
		"تعولجنا",
		"تعولجتم",
		"تعولجتنّ",
		"تعولجوا",
		"تعولجن",
		"متعالج",
		"أشير",
		"أشيرا",
		"أشيرتا",
		"أشيروا",
		"تشار",
		"تشارين",
		"يشار",
		"تشاران",
		"يشاران",
		"نشار",
		"تشارون",
		"يشارون",
		"جيء",
		"جيئت",
		"جيئا",
		"جيئتا",
		"جيئوا",
		"أجاء",
		"تجاء",
		"تجائين",
		"يجاء",
		"تجاءان",
		"يجاءان",
		"نجاء",
		"تجائون",
		"تجأن",
		"يجائون",
		"يجأن",
		"يوصى",
		"توصى",
		"نوصى",
		"موصى",
		"احتيج",
		"احتيجت",
		"احتيجا",
		"احتيجتا",
		"احتيجوا",
		"تعطى",
		"يعطى",
		"نعطى",
		"معطى",
		"تعوليت",
		"تعولي",
		"تعوليتما",
		"تعوليا",
		"تعوليتا",
		"تعولينا",
		"تعوليتم",
		"تعوليتنّ",
		"تعولوا",
		"تعولين",
		" شوركت",
		"شورك",
		"شوركتما",
		"شوركا",
		"شوركتا",
		"شوركنا",
		"شوركتم",
		"شوركتنّ",
		"شوركوا",
		"شوركن",
		"تتولّى",
		"يتولّى",
		"نتولّى",
		"زيد",
		"زيدت",
		"زيدا",
		"زيدتا",
		"زيدوا",
		"أزاد",
		"تزاد",
		"تزادين",
		"يزاد",
		"تزادان",
		"يزادان",
		"نزاد",
		"تزادون",
		"يزادون",
		"سوعدت",
		"سوعد",
		"سوعدتما",
		"سوعدا",
		"سوعدتا",
		"سوعدنا",
		"سوعدتم",
		"سوعدتنّ",
		"سوعدوا",
		"سوعدن",
		"رئيت",
		"رئي",
		"رئيتما",
		"رئيا",
		"رئيتا",
		"رئينا",
		"رئيتم",
		"رئيتنّ",
		"رؤوا",
		"رئين",
		"تفووضت",
		"تفووض",
		"تفووضتما",
		"تفووضا",
		"تفووضتا",
		"تفووضنا",
		"تفووضتم",
		"تفووضتنّ",
		"تفووضوا",
		"تفووضن",
		"تزويدت",
		"تزويد",
		"تزويدتما",
		"تزويدا",
		"تزويدتا",
		"تزويدنا",
		"تزويدتم",
		"تزويدتنّ",
		"تزويدوا",
		"تزويدن",
		"تتلقّى",
		"يتلقّى",
		"نتلقّى",
		"لوحظت",
		"لوحظ",
		"لوحظتما",
		"لوحظا",
		"لوحظتا",
		"لوحظنا",
		"لوحظتم",
		"لوحظتنّ",
		"لوحظوا",
		"لوحظن",
		"تسعى",
		"يسعى",
		"نسعى",
		"أوتيت",
		"أوتي",
		"أوتيتما",
		"أوتيا",
		"أوتيتا",
		"أوتينا",
		"أوتيتم",
		"أوتيتنّ",
		"أوتوا",
		"أوتين",
		"ووفقت",
		"ووفق",
		"ووفقتما",
		"ووفقا",
		"ووفقتا",
		"ووفقنا",
		"ووفقتم",
		"ووفقتنّ",
		"ووفقوا",
		"ووفقن",
		"إين",
		"إينت",
		"إينا",
		"إينتا",
		"إينوا",
		"أؤان",
		"تؤان",
		"تؤانين",
		"يؤان",
		"تؤانان",
		"يؤانان",
		"نؤان",
		"تؤانون",
		"يؤانون",
		"أوخذت",
		"أوخذ",
		"أوخذتما",
		"أوخذا",
		"أوخذتا",
		"أوخذنا",
		"أوخذتم",
		"أوخذتنّ",
		"أوخذوا",
		"أوخذن",
		"لهيت",
		"لهي",
		"لهيتما",
		"لهيا",
		"لهيتا",
		"لهينا",
		"لهيتم",
		"لهيتم",
		"لهوا",
		"لهين",
		"ألهى",
		"تلهى",
		"يلهى",
		"تلهى",
		"تلهيان",
		"يلهيان",
		"نلهى",
		"يلهين",
		"تتبقّى",
		"يتبقّى",
		"نتبقّى",
		"تنوولت",
		"تنوول",
		"تنوولتما",
		"تنوولا",
		"تنوولتا",
		"تنوولنا",
		"تنوولتم",
		"تنوولتنّ",
		"تنوولوا",
		"تنوولن",
		"تووجهت",
		"تووجه",
		"تووجهتما",
		"تووجها",
		"تووجهتا",
		"تووجهنا",
		"تووجهتم",
		"تووجهتنّ",
		"تووجهوا",
		"تووجهن",
		"تبودلت",
		"تبودل",
		"تبودلتما",
		"تبودلا",
		"تبودلتا",
		"تبودلنا",
		"تبودلتم",
		"تبودلتم",
		"تبودلوا",
		"تبودلن",
		"تعورضت",
		"تعورض",
		"تعورضتما",
		"تعورضا",
		"تعورضتا",
		"تعورضنا",
		"تعورضتم",
		"تعورضتنّ",
		"تعورضوا",
		"تعورضن",
		"تعورضن",
		"تعنى",
		"يعنى",
		"نعنى",
		"طولبت",
		"طولب",
		"طولبتما",
		"طولبا",
		"طولبتا",
		"طولبنا",
		"طولبتم",
		"طولبتنّ",
		"طولبوا",
		"طولبن",
		"قيم",
		"قيمت",
		"قيما",
		"قيمتا",
		"قيموا",
		"أقام",
		"تقام",
		"تقامين",
		"يقام",
		"تقامان",
		"يقامان",
		"نقام",
		"تقامون",
		"يقامون",
		"أنشئت",
		"أنشئ",
		"أنشئتما",
		"أنشئا",
		"أنشئتا",
		"أنشئنا",
		"أنشئتم",
		"أنشئتنّ",
		"أنشئوا",
		"أنشئن",
		"تنشأ",
		"تنشئين",
		"ينشأ",
		"تنشآن",
		"ينشآن",
		"ننشأ",
		"تنشأون",
		"ينشأون",
		"ينشأن",
		"تنشأن",
		"غطّي",
		"تغطّى",
		"يغطّى",
		"نغطّى",
		"قوتلت",
		"قوتل",
		"قوتلتما",
		"قوتلا",
		"قوتلتا",
		"قوتلنا",
		"قوتلنا",
		"قوتلتنّ",
		"قوتلوا",
		"قوتلن",
		"أسمى",
		"تسمى",
		"يسمى",
		"نسمى",
		"أوثرت",
		"أوثر",
		"أوثرتما",
		"أوثرا",
		"أوثرتا",
		"أوثرنا",
		"أوثرتم",
		"أوثرتنّ",
		"أوثروا",
		"أوثرن",
		"غنّي",
		"أغنّى",
		"تغنّى",
		"يغنّى",
		"نغنّى",
		"استفيد",
		"استفيدت",
		"استفيدا",
		"استفيدتا",
		"استفيدوا",
		"أستفاد",
		"تستفاد",
		"تستفادين",
		"يستفاد",
		"تستفادان",
		"يستفادان",
		"نستفاد",
		"تستفادون",
		"يستفادون",
		"أثير",
		"أثيرت",
		"أثيرا",
		"أثيرا",
		"أثيروا",
		"أثار",
		"تثار",
		"تثارين",
		"يثار",
		"تثاران",
		"يثاران",
		"نثار",
		"تثارون",
		"يثارون",
		"تدّعى",
		"يدّعى",
		"ندّعى",
		"عيش",
		"عيشت",
		"عيشا",
		"عيشتا",
		"عيشوا",
		"أعاش",
		"تعاش",
		"تعاشين",
		"يعاش",
		"تعاشان",
		"يعاشان",
		"نعاش",
		"تعاشون",
		"يعاشون",
		"ووجهت",
		"ووجه",
		"ووجهتما",
		"ووجها",
		"ووجهتا",
		"ووجهنا",
		"ووجهتم",
		"ووجهتنّ",
		"ووجهوا",
		"ووجهن",
		"دعيت",
		"دعي",
		"دعيا",
		"دعيتا",
		"دعينا",
		"دعيتم",
		"دعيتنّ",
		"دعوا",
		"دعين",
		"أدعى",
		"تدعى",
		"تدعين",
		"تدعين",
		"تدعيان",
		"يدعيان",
		"يدعين",
		"اختير",
		"اختيرت",
		"اختيرا",
		"اختيرتا",
		"اختيروا",
		"اخترن",
		"شوهدت",
		"شوهد",
		"شوهدتما",
		"شوهدا",
		"شوهدتا",
		"شوهدنا",
		"شوهدتم",
		"شوهدتنّ",
		"شوهدوا",
		"شوهدن",
		"أدّي",
		"أؤدّى",
		"تؤدّى",
		"يؤدّى",
		"نؤدّى",
		"أفيدت",
		"أفيدا",
		"أفيدتا",
		"أفيدوا",
		"يفادون",
		"تفادون",
		"نفاد",
		"تفادان",
		"يفادان",
		"تفاد",
		"يفاد",
		"تفادين",
		"أفاد",
		"تكوملت",
		"تكومل",
		"تكوملتما",
		"تكوملا",
		"تكوملتا",
		"تكوملنا",
		"تكوملتم",
		"تكوملتنّ",
		"تكوملوا",
		"تكوملن",
		"أهنّئ",
		"تهنّئ",
		"تهنّئين",
		"يهنّئ",
		"يهنّئ",
		"يهنّئان",
		"تهنّئان",
		"نهنّئ",
		"تهنّئون",
		"تهنّئن",
		"هنّئوا",
		"هنّئن",
		"أهنّأ",
		"تهنّأ",
		"يهنّأ",
		"تهنّآن",
		"نهنّأ",
		"تهنّأون",
		"تهنّأن",
		"يهنّأون",
		"يهنّأن",
		"سوهمت",
		"سوهم",
		"سوهمتما",
		"سوهما",
		"سوهمتا",
		"سوهمنا",
		"سوهمتم",
		"سوهمتنّ",
		"سوهموا",
		"سوهمن",
		"أرمى",
		"ترمى",
		"يرمى",
		"نرمى",
		"أبلغت",
	];
}
